// Shared by the Settings cards that edit fields on the company document (Fulfillment & Products, Returns).
// Fields are bound straight to the store via vuex-map-fields, so state is already updated when save() runs;
// we only persist the changed keys. Changes are debounced so sliders and typing don't produce a write per event.
// The component needs a <v-form ref="settings_form"> around its fields, and shows `save_state` with <SettingsSaveStatus>.
import { mapState, mapGetters } from 'vuex'

export default {
  data(){
    return {
      save_state: '',   // '' | 'saving' | 'saved' | 'error'
      pending_keys: {},
      save_timer: null,
      status_timer: null,
    }
  },
  computed: {
    ...mapState({
      company: state => state.warehouse.company,
    }),
    ...mapGetters({
      get_plan: 'warehouse/get_plan',
    }),
  },
  methods: {
    save(key){
      this.pending_keys[key] = true
      clearTimeout(this.save_timer)
      this.save_timer = setTimeout(this.flush_save, 600)
    },
    async flush_save(){
      clearTimeout(this.save_timer)
      const keys = Object.keys(this.pending_keys)
      if(!keys.length) return
      // Keep the keys pending while invalid (e.g. half-typed email) so the next valid change saves them.
      if(!this.$refs.settings_form.validate()) return
      this.pending_keys = {}
      this.save_state = 'saving'
      try {
        await this.$store.dispatch('warehouse/save_company', keys)
        this.set_status('saved')
      } catch(e){
        this.set_status('error')
        this.$store.commit('app/SET_SNACK_BAR', `Could not save settings: ${e.message}`)
      }
    },
    set_status(state){
      this.save_state = state
      clearTimeout(this.status_timer)
      this.status_timer = setTimeout(() => { this.save_state = '' }, 2500)
    },
    // For v-btn-toggle: Vuetify emits undefined when the active button is clicked again, which we ignore.
    set_company_field(key, value){
      if(!value) return
      this[key] = value
      this.save(key)
    },
  },
  beforeDestroy(){
    clearTimeout(this.status_timer)
    if(Object.keys(this.pending_keys).length) this.flush_save()
  },
}
